export const Author = ({ name }: { name: string }) => {
    return (
        <div id="author" className="text-sm xl:text-md font-extralight">
            Av <span className="font-bold">{name}</span>
        </div>
    );
};
